angular.module("Main").controller("PaymentPayPalTerminCancelFailErrorController", ["$rootScope", "$scope", "$window", "$state", "$stateParams", "$location", "$translate", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $window, $state, $stateParams, $location, $translate, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            //unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});

        });
        BookingService.getCurrency().then(function (data) {
            vm.currency = data;
            if (vm.currency.Waehrung === "EUR")
                vm.currency.Waehrung = "€";
        });

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = false;
        vm.isTermin = true;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        if (!SessionService.getSessionId()) {
            $state.go("angebot", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;

            BookingService.getMeetingData($stateParams.oid).then(function (data) {

                vm.meetingData = ({
                    Name: data.booking.Artikel,
                    Preis: data.booking.Preis,
                    Day: data.booking.Start,
                    End: data.booking.Ende,
                    Start: data.booking.Start,
                    RessourcenIds: data.booking.RessourcesIds,
                    RIds: data.booking.RessourcesIds,
                    TerminNr: data.booking.TerminNr,
                    TerminartNr: data.booking.TerminartNr,
                    Dauer: data.booking.Dauer,
                    Bezahlung: data.type.Bezahlung
                });

                SessionService.setAppointment(vm.meetingData.TerminartNr, vm.meetingData);
            });
            BookingService.deleteMemberFromAppointment($stateParams.oid).then(function () {
                    if (!_.isNil($stateParams.oid))
                        BookingService.cancelReservation($stateParams.oid, $translate.use(), 'ERROR');
            }).catch(function () {
                vm.hasError = true;
            });
        }

    }]);
